import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import { format } from '@mixins/decimal';
import Model from '@models/model';

export default class ProposalSubscription extends Model {
    item = {};

    resource() {
        return 'subscriptions';
    }

    get formFieldCasts() {
        return {
            cost: CurrencyFormatter.formFormat,
            price: CurrencyFormatter.formFormat,
        };
    }

    get propCasts() {
        return {
            qty: format,
        };
    }
}
